,<template>
  <div class="flex w-full h-full flex-no-wrap items-center">
    <div
      class="flex w-full bg-gray-400 border border-gray-400 rounded-full"
      :style="{ height }"
    >
      <div
        class="w-full rounded-full"
        :style="{ background: color, width: percent+'%'}"
      ></div>
    </div>
    <span
      v-if="showPercent"
      class="mx-3 font-semibold"
      :style=" {color: color}"
    >{{decimal(percent)}}%</span>
  </div>
</template>
<script>
export default {
  name: "ProgressBar",
  props: {
    percent: {
      type: Number,
      required: true,
      default: 0
    },
    color: {
      type: String,
      default: "#D8406C"
    },
    showPercent: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: "24px"
    }
  },
  data: () => ({
    skills: []
  }),
  methods: {
    decimal(value) {
      if (value) {
        return Number.parseFloat(Math.round(value * 100) / 100).toFixed(0);
      }
      return 0;
    }
  }
};
</script>
